import { FormItem } from "./FormItem";
import { Textarea } from "../Textarea";
import { Input } from "../Input";
import { Tag } from "../../Tag";

export class Checkbox extends FormItem {

    public getType() {
        return "Checkbox";
    }

    public getValue() {
        return this.getITag().getAttribute("checked") !== undefined;
    }

    protected initialize(data: any) {
        super.initialize(data);
        let t: HTMLElement = null;
        if (this.getTag()) {
            t = (this.getTag() as any).findByTag("input");
        } else {
            t = this.findByTag("input");
        }

        this.addToData("itag", this.get("textarea") ? new Textarea(t) : new Input(t));

        if (this.get("textarea")) {
            const t: Tag = this.getITag();

            const listenerF = () => {
                if (this.has("remL")) {
                    return;
                }
                t.fixHeight();
                t.focus();
                this.addToData("remL", true);
            };
            this.addListener("input", listenerF);

            t.fixHeight();
            t.focus();
        }
    }

    protected createSelf(): void {

        let input: any = null,
            val = this.trans("value");

        const attrs = [
            {n: "ft", v: "txtl"},
            {n: "type", v: this.get("it") || "text"},
            {n: "contenteditable", v: true},
        ];
        if (this.get("it") !== "date" && this.get("it") !== "datetime-local") {
            attrs.push({n: "placeholder", v: this.get("ph") || this.trans("label")});
        } else if (this.get("it") !== "datetime-local") {
            if (val) {
                const date = new Date(val);
                val = date.getFullYear() + "-" + date.getMonth() + "-" + date.getDate();
            }
        } else {
            attrs.push({n: "min", v: this.trans("dtmin")});
        }
        attrs.push({n: "value", v: val});

        if (this.get("ft") === "txtl") {
            input = {
                attributes: attrs,
                class: "textlinebox",
                t: "input",
                it: this.get("it"),
            };
        } else {
            input = {
                attributes: [
                    {n: "ft", v: "txt"},
                    {n: "contenteditable", v: true},
                    {n: "placeholder", v: this.get("ph") || this.trans("label")},
                    {n: "value", v: this.trans("value")},
                ],
                class: "textbox",
                t: "textarea",
                v: this.trans("value"),
            };
        }

        const c = this.createItemTag(input);

        this.setElement(c.getElement());
    }
}
